export const break_logo_light = "https://i.imgur.com/oKDYTR1.png";
export const break_logo_dark = "https://i.imgur.com/DFBAbvw.png";

export const fj_logo = "https://i.imgur.com/fTA6yAa.jpeg";
export const fj_logo_dark_bg = "https://i.imgur.com/fTA6yAa.jpeg";

export const landing_bg_img = "https://i.imgur.com/NElmTZV.png";
export const workbook_url =
  "https://www.dropbox.com/scl/fi/soz6w8s1tzjb2wb5avb0u/BPM-Workbook-Lecture-Slides.pdf?rlkey=m3iiqnfjb63e7f0i5wj4xppb1&st=rqi85uld&dl=0";

export const video_1_url = "https://player.vimeo.com/video/863676616";
export const video_2_url = "https://player.vimeo.com/video/853157907";
export const video_3_url = "https://player.vimeo.com/video/853169120";

// Landing page text constants

// Main text
export const landing_text_report =
  "Thank you for your submission! We have received your answers and you'll be contacted with further instructions.";
export const landing_text_start = () => {
  return (
    <>
      <strong>
        Thank you for participating in Brain Pattern Mapping. 
      </strong>
      <br></br>
      <br></br>
      Please rest assured that your privacy is of the utmost importance to us —
      your answers to this questionnaire will not be shared with your employer,
      only insights into your behavior patterns will be shared.
      <br></br>
      <br></br>
      You can start now. If you need to stop at any point and come back, we’ll
      save your progress. We’ve also given you access to bonus videos that you
      can view at your convenience.
    </>
  );
};
export const landing_text_progress = () => {
  return (
    <>
      <strong>
        Thank you for participating in Brain Pattern Mapping. 
      </strong>{" "}
      <br></br>
      <br></br>
      Please rest assured that your privacy is of the utmost importance to us —
      your answers to this questionnaire will not be shared with your employer,
      only insights into your behavior patterns will be shared.
      <br></br>
      <br></br>
      Click the button below to resume your diagnostic. We’ve also given you
      access to bonus videos that you can view at your convenience.
    </>
  );
};

// Renders the objective text depending on step number
export const render_landing_objective = (step) => {
  switch (step) {
    case 2:
      return (
        <>
          The lens through which you view your world is a{" "}
          <strong>byproduct of your childhood experiences.</strong> This lecture
          discusses the specific factors that shape your brain’s definition of
          safety and walks you through a series of prompts to help you{" "}
          <strong>
            tap into the information needed to complete your Brain Pattern
            Mapping.
          </strong>
        </>
      );
    case 3:
      return (
        <>
          The Timeline Process Exercise is an{" "}
          <strong>
            important tool that serves as a foundation for your Brain Pattern
            Map.
          </strong>{" "}
          This lecture provides a step-by-step breakdown of how to
          <strong>identify and summarize</strong> your repetitive childhood
          experiences into{" "}
          <strong>3 concise data streams, each linked to an emotion.</strong>
        </>
      );
    case 4:
      return (
        <>
          This lecture{" "}
          <strong>
            walks you through the initial stages of understanding how your
            childhood shaped your beliefs
          </strong>{" "}
          about people, situations and the world around you. You'll learn about
          how origin and adaptive source belief patterns are formed and how they
          shape the way you perceive reality, respond to your environment and
          make decisions about your future.
        </>
      );
    default:
      return null;
  }
};

// Renders the takeaway text depending on step number
export const render_landing_takeaway = (step) => {
  switch (step) {
    case 2:
      return (
        <>
          Your brain has been patterned by the{" "}
          <strong>
            cause and effect relationship of your adversely perceived repetitive
            childhood experiences.
          </strong>{" "}
          This pattern impacts how you engage with the world around you.
        </>
      );
    case 3:
      return (
        <>
          How you perceived safety and stability as a child provides us with
          more insight than the objective truth here.
          <strong>
            Anything that does not support innocence, curiosity or love, when
            experienced with repetition, can be a source of pain and suffering.
          </strong>{" "}
          How you responded across the timeline between ages 0-14 informs your
          origin, protective and escalating emotions.
        </>
      );
    case 4:
      return (
        <>
          In preparation for your upcoming Brain Pattern Mapping session, you
          should have a basic understanding of the different source beliefs and
          what <strong>inputs</strong> contributed to the{" "}
          <strong>output</strong> of who you are. Understanding{" "}
          <strong>where your brain is fundamentally stuck</strong> in terms of
          socio-emotional maturity is an important step in the diagnostic
          process.
        </>
      );
    default:
      return null;
  }
};
// Renders the action text depending on step number
export const render_landing_action_step = (step) => {
  switch (step) {
    case 2:
      return (
        <>
          Start to consider <strong>what was happening around you</strong> and
          who the most influential <strong>cast of character</strong> were in
          your early years.{" "}
          <strong>Respond to the prompts on pages 22-26</strong> and have your
          notes ready for the next lecture.
        </>
      );
    case 3:
      return (
        <>
          <strong>Complete pages 33 and 35</strong> of your Brain Pattern
          Mapping Workbook. Do your best to answer the prompts in a summarized
          way, focusing on details such as your{" "}
          <strong>
            behavior, voice tone, body language, decision making, and the
            general tendencies{" "}
          </strong>
          in your daily life. Refer back to the working definitions of emotional
          states when describing your emotional response. Have these pages ready
          for your diagnostic session.
        </>
      );
    case 4:
      return (
        <>
          Block off <strong>30 minutes of uninterrupted time</strong> on your
          calendar to complete your online diagnostics session using the
          computer model.
        </>
      );
    default:
      return null;
  }
};
// Bottom text
export const bottom_text_report = "BACK TO TOP";
export const bottom_text_start = () => {
  return (
    <>
      You can start now. If you need to stop at any point and <br /> come back,
      we’ll save your progress.
    </>
  );
};
export const bottom_text_progress = () => {
  return (
    <>
      You’re almost there. We just need you to complete a few
      <br /> more questions to finish the diagnostic.
    </>
  );
};
